module.exports = __webpack_public_path__ + "static/media/43_A.9505bd4b.png";